var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 30L23.6134 25.3877M23.6134 25.3877L19 19H22.0547L25.3877 23.6134L30 19M23.6134 25.3877L26.9442 30H30L25.3866 23.6123",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 24.5C39 32.5084 32.5084 39 24.5 39C16.4917 39 10 32.5084 10 24.5C10 16.4917 16.4917 10 24.5 10C32.5084 10 39 16.4917 39 24.5Z",
    stroke: "#F7F7F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTwitterWhite);
export default __webpack_public_path__ + "static/media/IconsTwitterWhite.17cbe748001207e198de38a73af3542b.svg";
export { ForwardRef as ReactComponent };